// extracted by mini-css-extract-plugin
export default {"root":"homepage-layout-headline_root__nkbef"};